<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Kepada`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black">
                    <div class="m-d-16 p-x-2">
                        <SOInputSearch id="cari-nomor" value="" :doSearching="doSearch" :delay-time="2000" />
                    </div>
                    <div class="m-t-32" v-if="isFetching">
                        <SOLoadMoreLoading :id="'search-customer-phone'" :loading="isFetching" />
                    </div>
                    <div class="md-content" v-if="!isFetching">
                        <div class="wrapper-list" :class="{ active: isActive('all') }">
                            <div
                                class="d-flex-between-center"
                                @click="selected({ nama_customer: 'Semua nomor', idcustomer: 'all' })"
                            >
                                <div>
                                    <div>
                                        <span class="f-16 f-semi f-c-black">Semua nomor</span>
                                    </div>
                                    <div class="f-12 f-c-midgrey f-regular">
                                        <span class="count-msg">Total {{ getTotalPesan }} pesan</span>
                                    </div>
                                </div>
                                <div>
                                    <IconBased width="16" height="11" v-if="isActive('all')">
                                        <template v-slot:icons>
                                            <Centang />
                                        </template>
                                    </IconBased>
                                    <IconBased width="16" height="11" v-else>
                                        <template v-slot:icons>
                                            <NextStep icon-fill="#C8D0DD" />
                                        </template>
                                    </IconBased>
                                </div>
                            </div>
                        </div>
                        <div
                            class="wrapper-list"
                            v-for="(list, idx) in listCustomer"
                            :key="`cs-phone-${idx}`"
                            :class="{ active: isActive(list.idcustomer) }"
                        >
                            <div class="d-flex-between-center" @click="selected(list)">
                                <div>
                                    <div class="d-flex" style="align-item: baseline;">
                                        <label class="m-d-0 f-16 f-semi f-c-black f-cont cs-name">
                                            {{ list.nama_customer }}
                                        </label>
                                        <label class="m-d-0 f-14 f-regular f-c-midgrey"> +{{ list.number }} </label>
                                    </div>
                                    <div class="f-12 f-c-midgrey f-regular">
                                        <span class="count-msg">{{ list.msg_count }} Pesan</span>
                                        <span>Terakhir {{ $moment(list.last_msg).format("Do MMM YYYY, HH:mm") }}</span>
                                    </div>
                                </div>
                                <div>
                                    <IconBased width="16" height="11" v-if="isActive(list.idcustomer)">
                                        <template v-slot:icons>
                                            <Centang />
                                        </template>
                                    </IconBased>
                                    <IconBased width="16" height="11" v-else>
                                        <template v-slot:icons>
                                            <NextStep icon-fill="#C8D0DD" />
                                        </template>
                                    </IconBased>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import IconBased from "../iconPack/IconBased.vue";
import Centang from "../iconPack/Centang.vue";
import NextStep from "../iconPack/NextStep0812.vue";

import { moduleName } from "../../store/state";

export default {
    name: "SearchNumber",
    components: {
        SOSlotModal,
        SOInputSearch,
        SOLoadMoreLoading,
        IconBased,
        Centang,
        NextStep,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.riwayat_pesan",
            modalId: "modal-cari-nomor",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    watch: {
        customerId: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.resetListPesan();
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            listCustomer: "listCustomer",
            customerId: "customerId",
        }),
        getIdDevice() {
            return this.$route.params.id_device;
        },
        isActive() {
            return (phone) => {
                return this.customerId === phone ? true : false;
            };
        },
        getTotalPesan() {
            let counter = 0;

            this.listCustomer.forEach((lc) => {
                counter += lc.msg_count;
            });

            return counter;
        },
    },
    methods: {
        ...mapActions({
            getListCustomer: `${moduleName}/getListCustomer`,
            setSelectedCustomer: `${moduleName}/setSelectedCustomer`,
            resetListPesan: `${moduleName}/resetListPesan`,
        }),
        init() {
            this.getListCustomer({ idMesin: this.getIdDevice, key: "" });
        },
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        doSearch(val) {
            this.getListCustomer({ idMesin: this.getIdDevice, key: val });
        },
        async selected(data) {
            await this.setSelectedCustomer(data);
            await this.back();
        },
    },
};
</script>

<style scoped>
.md-content {
    max-height: 50vh;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-left: -20px;
    margin-right: -20px;
}
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.wrapper-list {
    padding: 12px 20px;
}
.active {
    background-color: #edf5ff;
}
.count-msg {
    background: #ededed;
    border-radius: 3px;
    padding: 1px 4px;
}

.active .count-msg {
    border: 1px solid #c8d0dd;
    background: unset;
}

.cs-name {
    max-width: 130px;
    margin-right: 6px;
}

@media (min-width: 350px) {
    .cs-name {
        max-width: 165px;
    }
}

@media (min-width: 400px) {
    .cs-name {
        max-width: 200px;
    }
}
</style>
